import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["display", "input"]

    edit() {
        this.displayTarget.classList.add('hidden')
        this.inputTarget.classList.remove('hidden')
        this.inputTarget.focus()
        this.inputTarget.select()
    }

    save() {
        this.displayTarget.classList.remove('hidden')
        this.inputTarget.classList.add('hidden')
        this.updateDisplay()
    }

    keydown(event) {
        if (event.key === 'Enter') {
            event.preventDefault()
            this.save()
        } else if (event.key === 'Escape') {
            // Revert to original value on Escape
            this.inputTarget.value = this.originalValue || ''
            this.save()
        }
    }

    updateDisplay() {
        const value = this.inputTarget.value
        const textSpan = this.displayTarget.querySelector('[data-text]')

        if (textSpan) {
            if (value) {
                textSpan.textContent = this.formatValue(value)
                textSpan.classList.remove('hidden')
            } else {
                textSpan.textContent = ''
                textSpan.classList.add('hidden')
            }
        }
    }

    formatValue(value) {
        const inputType = this.inputTarget.type

        if (inputType === 'date' && value) {
            const date = new Date(value + 'T00:00:00')
            const now = new Date()
            const options = { month: 'short', day: 'numeric' }
            if (date.getFullYear() !== now.getFullYear()) {
                options.year = 'numeric'
            }
            return date.toLocaleDateString('en-US', options)
        }

        return value || 'Not set'
    }

    // Store original value when editing starts
    connect() {
        this.inputTarget.addEventListener('focus', () => {
            this.originalValue = this.inputTarget.value
        })
    }
}
